import React, { useEffect, useMemo, useState } from 'react';

import styles from './sheetSync.module.css';
import LinkEditor from './LinkEditor';
import { deltaText, money, plainReason, problemKind, singleExact } from './sheetSyncFormat';

const FILTERS = [
  ['all', 'ÐÑÐµ', 'ÐÑÐµ ÑÑÑÐ¾ÐºÐ¸, ÐºÐ¾ÑÐ¾ÑÑÐµ Ð½Ðµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÐ¾Ð¿Ð¾ÑÑÐ°Ð²Ð¸ÑÑ'],
  ['exact', 'ÐÑÑÑ ÑÐ¾ÑÐ½Ð¾Ðµ ÑÐ¾Ð²Ð¿Ð°Ð´ÐµÐ½Ð¸Ðµ', 'ÐÑÑÑ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ Ð¿ÑÐ¸ÐºÐ°Ð·Ð° Ñ ÑÐ°ÐºÐ¾Ð¹ Ð¶Ðµ ÑÐµÐ½Ð¾Ð¹: Ð¿ÑÐ¸Ð²ÑÐ·ÐºÐ° Ð½Ð¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð¸Ð·Ð¼ÐµÐ½Ð¸Ñ'],
  ['differs', 'Ð¦ÐµÐ½Ð° Ð´ÑÑÐ³Ð°Ñ', 'ÐÐ¾Ð´ÑÐ¾Ð´ÑÑÐ¸Ðµ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ð¸ ÐµÑÑÑ, Ð½Ð¾ ÑÐµÐ½Ð° Ð² ÑÐ°Ð±Ð»Ð¸ÑÐµ Ð¾ÑÐ»Ð¸ÑÐ°ÐµÑÑÑ Ð¾Ñ ÑÐµÐ½Ñ Ð² Ð¿ÑÐ¸ÐºÐ°Ð·Ðµ'],
  ['none', 'ÐÐµÑ Ð¿Ð¾Ð´ÑÐºÐ°Ð·ÐºÐ¸', 'ÐÐ¾Ð´ÑÐ¾Ð´ÑÑÐµÐ¹ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ð¸ Ð½Ðµ Ð½Ð°ÑÐ»Ð¾ÑÑ: Ð²ÑÐ±ÐµÑÐ¸ÑÐµ Ð²ÑÑÑÐ½ÑÑ Ð¸Ð»Ð¸ Ð¿ÑÐ¾Ð¿ÑÑÑÐ¸ÑÐµ ÑÑÑÐ¾ÐºÑ'],
];

// Ð§ÑÐ¾ ÑÐ»ÑÑÐ¸ÑÑÑ Ñ ÑÐµÐ½Ð¾Ð¹ Ð¿Ð¾ÑÐ»Ðµ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÐ¸ Ðº Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð¹ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ð¸ â Ð¿ÑÐ¾ÑÑÑÐ¼Ð¸ ÑÐ»Ð¾Ð²Ð°Ð¼Ð¸
const Effect = ({ suggestion, price }) => {
  if (!suggestion) return <span className={styles.muted}>ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ, Ð¸ Ð·Ð´ÐµÑÑ Ð¿Ð¾ÑÐ²Ð¸ÑÑÑ, ÑÑÐ¾ Ð¸Ð·Ð¼ÐµÐ½Ð¸ÑÑÑ</span>;
  if (suggestion.priceMatches)
    return <span className={styles.effectOk}>Ð¦ÐµÐ½Ð° ÑÐ¾Ð²Ð¿Ð°Ð´Ð°ÐµÑ. ÐÐ¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð¸Ð·Ð¼ÐµÐ½Ð¸ÑÑÑ</span>;
  return (
    <span className={styles.effectWarn}>
      Ð¦ÐµÐ½Ð° Ð² Ð¿ÑÐ¸ÐºÐ°Ð·Ðµ ÑÑÐ°Ð½ÐµÑ {money(price)} Ð²Ð¼ÐµÑÑÐ¾ {money(suggestion.rulePrice)} ({deltaText(suggestion.rulePrice, price)}). ÐÐ¾ÑÐ²Ð¸ÑÑÑ Ð²
      Â«Ð Ð¿ÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¸ÑÂ»
    </span>
  );
};

// Ð¡ÑÑÐ¾ÐºÐ¸ Google-ÑÐ°Ð±Ð»Ð¸ÑÑ, ÐºÐ¾ÑÐ¾ÑÑÐµ ÑÐ¸ÑÑÐµÐ¼Ð° Ð½Ðµ ÑÐ¼Ð¾Ð³Ð»Ð° ÑÐ°Ð¼Ð° ÑÐ¾Ð¿Ð¾ÑÑÐ°Ð²Ð¸ÑÑ Ñ Ð¿ÑÐ¸ÐºÐ°Ð·Ð¾Ð¼. ÐÐ»Ñ ÐºÐ°Ð¶Ð´Ð¾Ð¹ â Ð²ÑÐ±ÑÐ°ÑÑ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ Ð¿ÑÐ¸ÐºÐ°Ð·Ð°
// Ð¸Ð· Ð¿Ð¾Ð´ÑÐºÐ°Ð·Ð¾Ðº (Ð¸Ð»Ð¸ Ð²ÑÑÑÐ½ÑÑ) Ð¸ Ð½Ð°Ð¶Ð°ÑÑ Â«ÐÑÐ¸Ð²ÑÐ·Ð°ÑÑÂ», Ð»Ð¸Ð±Ð¾ Ð¸ÑÐºÐ»ÑÑÐ¸ÑÑ ÑÑÑÐ¾ÐºÑ Ð¸Ð· ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð°ÑÐ¸Ð¸
const ProblemsTable = ({ problems, marks, busy, onLink, onIgnore }) => {
  const [filter, setFilter] = useState('all');
  const [choice, setChoice] = useState({});
  const [editorKey, setEditorKey] = useState(null);
  const [confirmBulk, setConfirmBulk] = useState(false);

  useEffect(() => {
    if (!confirmBulk) return undefined;
    const timer = setTimeout(() => setConfirmBulk(false), 6000);
    return () => clearTimeout(timer);
  }, [confirmBulk]);

  const counts = useMemo(() => {
    const c = { all: problems.length, exact: 0, differs: 0, none: 0 };
    problems.forEach((p) => {
      c[problemKind(p)] += 1;
    });
    return c;
  }, [problems]);

  const bulk = useMemo(() => problems.filter((p) => singleExact(p)), [problems]);
  const visible = filter === 'all' ? problems : problems.filter((p) => problemKind(p) === filter);

  // ÐÑÐ±ÑÐ°Ð½Ð½Ð°Ñ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ: ÑÐ¾, ÑÑÐ¾ Ð²ÑÐ±ÑÐ°Ð» ÑÐµÐ»Ð¾Ð²ÐµÐº; Ð¸Ð½Ð°ÑÐµ ÐµÐ´Ð¸Ð½ÑÑÐ²ÐµÐ½Ð½Ð°Ñ Ñ ÑÐ¾Ð²Ð¿Ð°Ð²ÑÐµÐ¹ ÑÐµÐ½Ð¾Ð¹
  const picked = (p) => {
    const i = choice[p.key];
    if (i !== undefined) return i === '' ? null : p.suggestions[Number(i)];
    return singleExact(p);
  };

  const linkAll = () => {
    if (!confirmBulk) {
      setConfirmBulk(true);
      return;
    }
    setConfirmBulk(false);
    onLink(
      bulk.flatMap((p) => singleExact(p).keys.map((k) => ({ sheetKey: p.key, ...k }))),
      `ÐÑÐ¸Ð²ÑÐ·Ð°Ð½Ð¾ ÑÑÑÐ¾Ðº: ${bulk.length}. Ð¦ÐµÐ½Ñ Ð½Ðµ Ð¼ÐµÐ½ÑÐ»Ð¸ÑÑ, Ð¿ÑÐ¸Ð²ÑÐ·ÐºÐ° ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð° ÑÑÐ°Ð·Ñ.`
    );
  };

  if (problems.length === 0) return <div className={styles.empty}>ÐÑÐ¾Ð±Ð»ÐµÐ¼ Ð½ÐµÑ: Ð²ÑÐµ ÑÑÑÐ¾ÐºÐ¸ ÑÐ°Ð±Ð»Ð¸ÑÑ ÑÐ¾Ð¿Ð¾ÑÑÐ°Ð²Ð»ÐµÐ½Ñ Ñ Ð¿ÑÐ¸ÐºÐ°Ð·Ð¾Ð¼</div>;

  return (
    <>
      <div className={styles.chips} role="group" aria-label="Ð¤Ð¸Ð»ÑÑÑ Ð¿ÑÐ¾Ð±Ð»ÐµÐ¼">
        {FILTERS.map(([key, title, hint]) => (
          <button
            key={key}
            type="button"
            title={hint}
            aria-pressed={filter === key}
            className={`${styles.chip} ${filter === key ? styles.chipActive : ''}`}
            onClick={() => setFilter(key)}
          >
            {title} <b>{counts[key]}</b>
          </button>
        ))}
      </div>

      {bulk.length > 0 && (
        <div className={styles.bulkBar}>
          <span>
            Ð£ <b>{bulk.length}</b> ÑÑÑÐ¾Ðº ÐµÑÑÑ ÑÐ¾Ð²Ð½Ð¾ Ð¾Ð´Ð½Ð° Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ Ð¿ÑÐ¸ÐºÐ°Ð·Ð° Ñ ÑÐ°ÐºÐ¾Ð¹ Ð¶Ðµ ÑÐµÐ½Ð¾Ð¹. ÐÑÐ¸Ð²ÑÐ·ÐºÐ° Ðº Ð½ÐµÐ¹ Ð½Ð¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð¸Ð·Ð¼ÐµÐ½Ð¸Ñ, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¸Ñ Ð¼Ð¾Ð¶Ð½Ð¾
            Ð¿ÑÐ¸Ð²ÑÐ·Ð°ÑÑ ÑÐ°Ð·Ð¾Ð¼.
          </span>
          <button type="button" className={confirmBulk ? styles.miniDanger : styles.miniPrimary} disabled={busy} onClick={linkAll}>
            {confirmBulk ? `Ð¢Ð¾ÑÐ½Ð¾ Ð¿ÑÐ¸Ð²ÑÐ·Ð°ÑÑ ${bulk.length}?` : `ÐÑÐ¸Ð²ÑÐ·Ð°ÑÑ Ð²ÑÐµ ${bulk.length}`}
          </button>
        </div>
      )}

      <div className={styles.tableWrap}>
        <table className={styles.problemsTable}>
          <colgroup>
            <col style={{ width: '6%' }} />
            <col style={{ width: '20%' }} />
            <col style={{ width: '8%' }} />
            <col style={{ width: '16%' }} />
            <col style={{ width: '23%' }} />
            <col style={{ width: '13%' }} />
            <col style={{ width: '14%' }} />
          </colgroup>
          <thead>
            <tr>
              <th title="ÐÐ½Ð°ÑÐµÐ½Ð¸Ðµ ÐºÐ¾Ð»Ð¾Ð½ÐºÐ¸ ID Ð² Google-ÑÐ°Ð±Ð»Ð¸ÑÐµ">ID</th>
              <th title="Ð§ÑÐ¾ Ð½Ð°Ð¿Ð¸ÑÐ°Ð½Ð¾ Ð² ÑÑÑÐ¾ÐºÐµ Google-ÑÐ°Ð±Ð»Ð¸ÑÑ">Ð¡ÑÑÐ¾ÐºÐ° Google-ÑÐ°Ð±Ð»Ð¸ÑÑ</th>
              <th className={styles.num}>Ð¦ÐµÐ½Ð° Ð² ÑÐ°Ð±Ð»Ð¸ÑÐµ</th>
              <th title="ÐÐ¾ÑÐµÐ¼Ñ ÑÐ¸ÑÑÐµÐ¼Ð° Ð½Ðµ ÑÐ¼Ð¾Ð³Ð»Ð° ÑÐ¾Ð¿Ð¾ÑÑÐ°Ð²Ð¸ÑÑ ÑÑÑÐ¾ÐºÑ ÑÐ°Ð¼Ð°">ÐÐ¾ÑÐµÐ¼Ñ Ð½Ðµ ÑÐ¾Ð¿Ð¾ÑÑÐ°Ð²Ð¸Ð»Ð°ÑÑ</th>
              <th title="ÐÐ¾Ð·Ð¸ÑÐ¸Ñ Ð² Ð¿ÑÐ¸ÐºÐ°Ð·Ðµ, Ðº ÐºÐ¾ÑÐ¾ÑÐ¾Ð¹ Ð¾ÑÐ½Ð¾ÑÐ¸ÑÑÑ ÑÑÑÐ¾ÐºÐ°. ÐÐ¾Ð´ÑÐºÐ°Ð·ÐºÐ¸ Ð¿Ð¾Ð´Ð¾Ð±ÑÐ°Ð½Ñ Ð¿Ð¾ Ð¼Ð°ÑÐºÐµ, Ð¼Ð¾Ð´ÐµÐ»Ð¸, Ð³Ð¾Ð´Ñ, ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸ Ð¸ ÑÐµÐ½Ðµ">
                Ð ÐºÐ°ÐºÐ¾Ð¹ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ð¸ Ð¿ÑÐ¸ÐºÐ°Ð·Ð° Ð¿ÑÐ¸Ð²ÑÐ·Ð°ÑÑ
              </th>
              <th>Ð§ÑÐ¾ Ð¸Ð·Ð¼ÐµÐ½Ð¸ÑÑÑ</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {visible.map((p) => {
              const sel = picked(p);
              const suggestions = p.suggestions || [];
              return (
                <React.Fragment key={p.key}>
                  <tr>
                    <td className={styles.cellKey}>{p.key}</td>
                    <td title={`${p.brand} ${p.model} ${p.year} Â· ${p.trim}`}>
                      {p.brand} {p.model} {p.year} Â· {p.trim}
                    </td>
                    <td className={styles.num}>{money(p.price)}</td>
                    <td className={styles.reasonCell}>{plainReason(p.reason)}</td>
                    <td>
                      {suggestions.length > 0 ? (
                        <select
                          className={styles.pick}
                          aria-label={`ÐÐ¾Ð·Ð¸ÑÐ¸Ñ Ð¿ÑÐ¸ÐºÐ°Ð·Ð° Ð´Ð»Ñ ${p.key}`}
                          value={sel ? String(suggestions.indexOf(sel)) : ''}
                          onChange={(e) => setChoice((prev) => ({ ...prev, [p.key]: e.target.value }))}
                        >
                          <option value="">â Ð²ÑÐ±ÐµÑÐ¸ÑÐµ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ Ð¿ÑÐ¸ÐºÐ°Ð·Ð° â</option>
                          {suggestions.map((s, i) => (
                            <option key={s.label} value={i}>
                              {s.label} Â· {money(s.rulePrice)}
                              {s.priceMatches ? ' â ÑÐµÐ½Ð° ÑÐ¾Ð²Ð¿Ð°Ð»Ð°' : ''}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <span className={styles.muted}>ÐÐ¾Ð´ÑÐ¾Ð´ÑÑÐµÐ¹ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ð¸ Ð½Ðµ Ð½Ð°ÑÐ»Ð¾ÑÑ</span>
                      )}
                      <button
                        type="button"
                        className={styles.linkBtn}
                        title="Ð£ÐºÐ°Ð·Ð°ÑÑ Ð¼Ð¾Ð´ÐµÐ»Ñ, ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ, Ð³Ð¾Ð´, Ð¾Ð±ÑÑÐ¼ Ð¸ Ð¿ÑÐ¸Ð²Ð¾Ð´ ÑÐ°Ð¼Ð¾Ð¼Ñ"
                        onClick={() => setEditorKey(editorKey === p.key ? null : p.key)}
                      >
                        ÐÑÐ±ÑÐ°ÑÑ Ð²ÑÑÑÐ½ÑÑ
                      </button>
                    </td>
                    <td className={styles.effectCell}>
                      <Effect suggestion={sel} price={p.price} />
                    </td>
                    <td className={styles.cellActions}>
                      <button
                        type="button"
                        className={styles.miniPrimary}
                        disabled={busy || !sel}
                        title={
                          sel
                            ? `Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÑ: ${p.key} Ð±ÑÐ´ÐµÑ Ð±ÑÐ°ÑÑ ÑÐµÐ½Ñ Ð¸Ð· Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð¹ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ð¸`
                            : 'Ð¡Ð½Ð°ÑÐ°Ð»Ð° Ð²ÑÐ±ÐµÑÐ¸ÑÐµ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ Ð¿ÑÐ¸ÐºÐ°Ð·Ð° Ð² ÑÐ¿Ð¸ÑÐºÐµ'
                        }
                        onClick={() =>
                          onLink(
                            sel.keys.map((k) => ({ sheetKey: p.key, ...k })),
                            `${p.key} Ð¿ÑÐ¸Ð²ÑÐ·Ð°Ð½Ð° Ðº Â«${sel.label}Â» Ð¸ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð°. Ð¦ÐµÐ½Ñ Ð¿Ð¾ÐºÐ° Ð½Ðµ Ð¼ÐµÐ½ÑÐ»Ð¸ÑÑ: ÑÐ¼Ð¾ÑÑÐ¸ÑÐµ Â«Ð Ð¿ÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¸ÑÂ».`
                          )
                        }
                      >
                        ÐÑÐ¸Ð²ÑÐ·Ð°ÑÑ
                      </button>
                      <button
                        type="button"
                        className={styles.mini}
                        disabled={busy}
                        title="ÐÑÐºÐ»ÑÑÐ¸ÑÑ ÑÑÑÐ¾ÐºÑ Ð¸Ð· ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð°ÑÐ¸Ð¸ (Ð²ÐµÑÐ½ÑÑÑ Ð¼Ð¾Ð¶Ð½Ð¾ Ð½Ð° Ð²ÐºÐ»Ð°Ð´ÐºÐµ Â«ÐÑÐ¸Ð²ÑÐ·ÐºÐ¸Â»)"
                        onClick={() => onIgnore(p.key)}
                      >
                        ÐÐµ ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð¸ÑÐ¾Ð²Ð°ÑÑ
                      </button>
                    </td>
                  </tr>
                  {editorKey === p.key && (
                    <tr>
                      <td colSpan={7} className={styles.editorRowCell}>
                        <LinkEditor
                          sheetKey={p.key}
                          problem={p}
                          marks={marks}
                          suggestedMarkId={suggestions[0]?.markId}
                          busy={busy}
                          onSave={(payload) => {
                            setEditorKey(null);
                            onLink(payload, `${p.key} Ð¿ÑÐ¸Ð²ÑÐ·Ð°Ð½Ð° Ð¸ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð°. Ð¦ÐµÐ½Ñ Ð¿Ð¾ÐºÐ° Ð½Ðµ Ð¼ÐµÐ½ÑÐ»Ð¸ÑÑ: ÑÐ¼Ð¾ÑÑÐ¸ÑÐµ Â«Ð Ð¿ÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¸ÑÂ».`);
                          }}
                          onCancel={() => setEditorKey(null)}
                        />
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
      {visible.length === 0 && <div className={styles.empty}>Ð ÑÑÐ¾Ð¹ Ð³ÑÑÐ¿Ð¿Ðµ Ð¿ÑÐ¾Ð±Ð»ÐµÐ¼ Ð½ÐµÑ</div>}
      <div className={styles.hint}>
        ÐÑÐ¶Ð½Ð¾Ð¹ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ð¸ Ð½ÐµÑ Ð² ÑÐ¿Ð¸ÑÐºÐµ? ÐÐ°Ð¶Ð¼Ð¸ÑÐµ Â«ÐÑÐ±ÑÐ°ÑÑ Ð²ÑÑÑÐ½ÑÑÂ» Ð¸ ÑÐºÐ°Ð¶Ð¸ÑÐµ Ð¼Ð¾Ð´ÐµÐ»Ñ, ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ, Ð³Ð¾Ð´, Ð¾Ð±ÑÑÐ¼ Ð¸ Ð¿ÑÐ¸Ð²Ð¾Ð´ Ð¸Ð· ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐ°. Ð¡ÑÑÐ¾ÐºÑ, ÐºÐ¾ÑÐ¾ÑÐ°Ñ Ð½Ðµ
        Ð¾ÑÐ½Ð¾ÑÐ¸ÑÑÑ Ðº Ð¿ÑÐ¸ÐºÐ°Ð·Ð°Ð¼, Ð¼Ð¾Ð¶Ð½Ð¾ Ð¸ÑÐºÐ»ÑÑÐ¸ÑÑ ÐºÐ½Ð¾Ð¿ÐºÐ¾Ð¹ Â«ÐÐµ ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð¸ÑÐ¾Ð²Ð°ÑÑÂ».
      </div>
    </>
  );
};

export default ProblemsTable;
